var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"works-card",on:{"click":function($event){return _vm.gotoDetail(_vm.item)}}},[_c('div',{staticClass:"product-name"},[_c('div',{staticClass:"name",attrs:{"title":_vm.item.name}},[_vm._v(_vm._s(_vm.item.name))])]),_c('img',{staticClass:"works-img",attrs:{"src":require('@/assets/images/展览.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }